<template>
  <div class="PersonelIoInfoInDateListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 50, 100, -1],
        'items-per-page-text': $t('rowsPerPage'),
        'show-first-last-page': true,
      }"
      :item-class="getItemBackColor"
    >
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      rowColors: [
        "PaleVioletRed", //   غیبت
        "Orange", //   ماموریت روزانه
        "OrangeRed", //   ماموریت روزانه - تأیید نشده
        "DarkOrange", //   ماموریت روزانه - تأیید شده - انتقال داده نشده
        "LightBlue", //   ماموریت ساعتی
        "SlateBlue", //   ماموریت ساعتی - تأیید نشده
        "DodgerBlue", //   ماموریت ساعتی - تأیید شده - انتقال داده نشده
        "ForestGreen", //   مرخصی روزانه
        "LightSeaGreen", //   مرخصی روزانه - تأیید نشده
        "GreenYellow", //   مرخصی روزانه - تأیید شده - انتقال داده نشده
        "LightSeaGreen", //   مرخصی ساعتی
        "DarkOliveGreen", //   مرخصی ساعتی - تأیید نشده
        "DarkSeaGreen", //   مرخصی ساعتی - تأیید شده - انتقال داده نشده
        "DarkMagenta", //   تاخیر سرویس
        "White", //   حضور در سازمان
      ],
      headers: [
        {
          text: this.$t("SectionCode"),
          value: "Section",
        },
        {
          text: this.$t("SectionName"),
          value: "SectionName",
        },
        {
          text: this.$t("card-no"),
          value: "PERNO",
        },
        {
          text: this.$t("person-name"),
          value: "PersonName",
        },
        {
          text: this.$t("attendanceStatus"),
          value: "PresenceText",
        },
        {
          text: this.$t("Start"),
          value: "StartTime",
        },
        {
          text: this.$t("End"),
          value: "EndTime",
        },
        {
          text: this.$t("description"),
          value: "Description",
        },
      ],
    };
  },
  methods: {
    getItemBackColor(item) {
      return this.rowColors[item.PresenceType];
    },
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
</style>